export function SignInIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 6L9.5 6M9.5 6L5.13636 2M9.5 6L5.13636 10"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 1V1C11.3856 1 12.3284 1 12.9142 1.58579C13.5 2.17157 13.5 3.11438 13.5 5V7C13.5 8.88562 13.5 9.82843 12.9142 10.4142C12.3284 11 11.3856 11 9.5 11V11"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
